<template>
  <div>
    <navbar class="navbar" />
    <v-card outlined >
      <v-card-text>
        <v-row><v-col><h3>ข้อมูลทั่วไป</h3></v-col></v-row>

        <v-row>
          <v-divider></v-divider>
        </v-row>
        <v-row>
          <v-col sm="12" md="12" lg="6" cols="12">
            <v-row>
              <v-col cols="12">
                <v-row>
                  <v-col>
                    <b> <v-icon>mdi-account-supervisor</v-icon> ข้อมูลลูกค้า</b>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                      <v-combobox
                        :items="customerData"
                        outlined
                        dense
                        autocomplete="off"
                        hide-details="auto"
                        item-text="name"
                        item-value="_id"
                        return-object
                        label="ค้นหาข้อมูลลูกค้า"
                        v-model="valueInput.selectCustomer"
                        @focus="findCustomer"
                        @keyup="findCustomer"
                        @change="selectCustomer"
                        :rules="rule.selectCustomer"
                      ></v-combobox>
                  </v-col>
                </v-row>

                <!-- <v-row>
                  <v-col>
                    <v-select
                      :items="itemsWarehouse"
                      label="คลังสินค้า"
                      item-value="_id"
                      item-text="name"
                      return-object
                      outlined
                      hide-details="auto"
                      dense
                        autocomplete="off"
                      v-model="selectedWarehose"
                      ref="orderWarehouseID"
                    ></v-select>
                  </v-col>
                </v-row> -->

                <v-row>
                  <v-divider class="mx-4"></v-divider>
                </v-row>

                <v-row>
                  <v-col>
                    <v-text-field
                      outlined
                      hide-details="auto"
                      dense
                        autocomplete="off"
                      label="ชื่อ - สกุล ลูกค้า"
                      v-model="valueInput.orderCustomerName"
                      :rules="rule.orderCustomerName"
                      ref="orderCustomerName"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <v-text-field
                      outlined
                      hide-details="auto"
                      dense
                        autocomplete="off"
                      label="ชื่อโซเชี่ยล"
                      v-model="valueInput.orderCustomerSocialName"
                      :rules="rule.orderCustomerSocialName"
                      ref="orderCustomerSocialName"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col sm="12" md="12" lg="6" cols="12">
                    <v-text-field
                      outlined
                      hide-details="auto"
                      dense
                        autocomplete="off"
                      label="เบอร์โทรศัพท์"
                      @keypress="handleInputNumber"
                      v-model="valueInput.orderCustomerPhone"
                      :rules="rule.orderCustomerPhone"
                      ref="orderCustomerPhone"
                    ></v-text-field>
                  </v-col>
                  <v-col sm="12" md="12" lg="6" cols="12">
                    <v-text-field
                      outlined
                      hide-details="auto"
                      dense
                        autocomplete="off"
                      label="อีเมล์"
                      v-model="valueInput.orderCustomerEmail"
                      :rules="rule.orderCustomerEmail"
                      ref="orderCustomerEmail"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <v-textarea
                      outlined
                      auto-grow
                      label="ที่อยู่"
                      hide-details="auto"
                      dense
                        autocomplete="off"
                      v-model="valueInput.orderCustomerAddress"
                      :rules="rule.orderCustomerAddress"
                      ref="orderCustomerAddress"
                    ></v-textarea>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <v-text-field
                      outlined
                      hide-details="auto"
                      dense
                        autocomplete="off"
                      label="รหัสไปษรณีย์"
                      maxlength="5"
                      v-model="valueInput.orderCustomerPostal"
                      :rules="rule.orderCustomerPostal"
                      ref="orderCustomerPostal"
                      @keypress="handleInputNumber"
                    ></v-text-field>
                  </v-col>
                </v-row>

              </v-col>
            </v-row>
          </v-col>
          <v-col sm="12" md="12" lg="6" cols="12">
              <v-row>
                <v-col cols="12">
                  <!-- <v-row>
                    <v-col>
                      <b> <v-icon>mdi-truck</v-icon> การจัดส่ง</b>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col>
                      <v-select
                        :items="itemsShippingType"
                        item-text="title"
                        item-value="type"
                        label="การจัดส่ง"
                        outlined
                        hide-details="auto"
                        dense
                        autocomplete="off"
                        v-model="valueInput.orderShippingType"
                        ref="orderShippingType"
                      ></v-select>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col>
                      <v-select
                        :items="itemsShippingCompany"
                        item-text="title"
                        item-value="type"
                        label="ผู้ให้บริการ การจัดส่ง"
                        outlined
                        hide-details="auto"
                        dense
                        autocomplete="off"
                        v-model="valueInput.orderShippingBy"
                        ref="orderShippingBy"
                      ></v-select>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-divider class="mx-4"></v-divider>
                  </v-row> -->

                  <v-row>
                    <v-col>
                      <b> <v-icon>mdi-credit-card-outline</v-icon> การชำระเงิน</b>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col>
                      <v-select
                        :items="itemsPaymentType"
                        v-model="valueInput.orderPaymentType"
                        item-text="title"
                        item-value="type"
                        label="เลือกวิธีการชำระเงิน"
                        outlined
                        hide-details="auto"
                        dense
                        autocomplete="off"
                        ref="orderPaymentType"
                      ></v-select>
                    </v-col>
                  </v-row>

                  <div v-if="valueInput.orderPaymentType === 'bank'" >
                    <v-row>
                      <v-col>
                        <v-checkbox
                          v-model="valueInput.orderVerifyPayment"
                          hide-details="auto"
                          dense
                        autocomplete="off"
                          label="แจ้งชำระเงิน"
                          ref="orderVerifyPayment"
                        ></v-checkbox>
                      </v-col>
                    </v-row>

                    <div v-if="valueInput.orderVerifyPayment === true">
                      <v-row>
                        <v-col>
                          <v-select
                            :items="itemsBankTransfer"
                            item-value="id"
                            label="เลือกธนาคารสำหรับงานชำระเงิน"
                            v-model="valueInput.orderPaymentSelectedBank"
                            outlined
                            hide-details="auto"
                            dense
                            autocomplete="off"
                            ref="orderPaymentSelectedBank"
                          >
                            <template slot="selection" slot-scope="data">
                              <img class="bankIcon" :src="data.item.icon">
                              <span>{{ data.item.title }}</span>
                            </template>

                            <template slot="item" slot-scope="data">
                              <img class="bankIcon" :src="data.item.icon">
                              <span>{{ data.item.title }}</span>
                            </template>
                          </v-select>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col>
                          <v-datetime-picker
                            label="วันที่ชำระเงิน"
                            v-model="valueInput.orderPaymentDate"
                            :text-field-props="[textFieldProps]"
                            hide-details="auto"
                            ref="orderPaymentDate"
                          >
                            <template slot="dateIcon">
                              <v-icon>mdi-calendar-range</v-icon>
                            </template>
                            <template slot="timeIcon">
                              <v-icon>mdi-clock-outline</v-icon>
                            </template>
                          </v-datetime-picker>
                        </v-col>
                      </v-row>

                      <!-- <v-row>
                        <v-col>
                          <picture-input
                            width="300"
                            height="300"
                            margin="16"
                            accept="image/jpeg,image/png"
                            size="10"
                            button-class="v-btn pictureInput primary"
                            :custom-strings="{
                              upload: '<h1>Upload!</h1>',
                              drag: 'รูปภาพ',
                            }"
                            :crop="true"
                            :removable="true"
                            removeButtonClass="v-btn pictureInput error"
                            @change="onChangePicture"
                            v-model="valueInput.orderPaymentImage"
                            :rules="rule.productImage"
                            >
                          </picture-input>
                        </v-col>
                      </v-row> -->

                      <v-row>
                        <v-col sm="12" md="12" lg="12" cols="12">
                          <v-file-input
                            accept="image/png, image/jpeg, image/bmp"
                            prepend-icon="mdi-camera"
                            label="รูปภาพ"
                            outlined
                            dense
                        autocomplete="off"
                            hide-details="auto"
                            :rules="rule.productImage"
                            @change="previewFiles"
                            ref="orderPaymentImage"
                          ></v-file-input>

                        </v-col>

                        <v-col v-if="blobURL" sm="12" md="12" lg="12" cols="12">
                          <v-img
                            max-height="auto"
                            max-width="250"
                            :src="blobURL"
                            style="display: block; margin: 0 auto"
                          />
                        </v-col>
                      </v-row>

                    </div>
                  </div>

                  <div v-if="valueInput.orderPaymentType === 'cod'">
                    <v-row>
                      <v-col>
                        <v-checkbox
                          v-model="valueInput.orderVerifyCOD"
                          hide-details="auto"
                          dense
                          autocomplete="off"
                          label="ยืนยันให้จัดส่ง COD"
                          ref="orderVerifyCOD"
                        ></v-checkbox>
                      </v-col>
                    </v-row>

                    <div v-if="valueInput.orderVerifyCOD === true">
                      <v-row>
                        <v-col>
                          <v-select
                            :items="valueInput.orderPaymentType"
                            item-text="title"
                            item-value="id"
                            label="บริการเก็บเงินปลายทาง"
                            outlined
                            hide-details="auto"
                            dense
                            autocomplete="off"
                            v-model="valueInput.orderPaymentCOD"
                            ref="orderPaymentCOD"
                          ></v-select>
                        </v-col>
                      </v-row>
                    </div>

                  </div>

                  <!-- <v-row>
                    <v-divider class="mx-4"></v-divider>
                  </v-row>

                  <v-row>
                    <v-col>
                      <b> <v-icon>mdi-account-plus</v-icon> พนักงานขาย</b>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col>
                      <v-select
                        :items="itemsSale"
                        item-text="name"
                        item-value="id"
                        label="พนักงานขาย"
                        outlined
                        hide-details="auto"
                        dense
                        autocomplete="off"
                        v-model="selectedOrderSale"
                        return-object
                        ref="orderSaleID"
                      ></v-select>
                    </v-col>
                  </v-row> -->

                </v-col>
              </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card class="mt-5" outlined>
      <v-card-text>
        <h3>รายการสินค้า</h3>
        <v-row>
          <v-divider style="margin: 10px 0"></v-divider>
        </v-row>

        <v-row>
          <v-col class="col-6">
              <v-text-field
                append-icon="mdi-magnify"
                label="ชิ่อสินค้า, รหัสสินค้า"
                outlined
                hide-details="auto"
                dense
                autocomplete="off"
                v-model="searchProduct"
              ></v-text-field>
          </v-col>
          <v-col class="col-2">
            <v-dialog
              v-model="dialogAddProduct"
              width="900"
              persistent
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  depressed
                  class="pa-5"
                  @click="getProduct()"
                >
                  <v-icon class="mr-5">mdi-magnify</v-icon>
                  ค้นหาสินค้า
                </v-btn>
              </template>

              <v-card outlined >
                <v-card-title
                  class="grey lighten-2"
                  primary-title
                >
                  เพิ่มสินค้า
                </v-card-title>

                <v-card-text>
                  <v-row>
                    <v-col>
                      <v-data-table
                        v-model="selectedProduct"
                        :headers="headersDataSelectProduct"
                        :items="itemsTableDataSelectProduct"
                        item-key="_id"
                        show-select
                      >

                      <template v-slot:item.image="{item}">
                        <v-img
                          :src="item.image"
                          width="30px"
                          style="margin: auto"
                        ></v-img>
                      </template>

                      <template v-slot:item.qty="{item}">
                        <!-- {{item.qty - item.minimumInventory}} -->
                        {{numberWithComma(item.qty)}}
                      </template>

                      <!-- <template v-slot:item.action="{item}">
                        <v-btn
                          text
                          color="primary"
                          @click="selectedProductOnTable(item)"
                        >
                         เลือกสินค้า
                        </v-btn>
                      </template> -->

                      </v-data-table>
                    </v-col>
                  </v-row>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="error"
                    text
                    @click="handleAddProduct('cancel')"
                  >
                    <v-icon>mdi-close</v-icon>
                    ยกเลิก
                  </v-btn>
                  <v-btn
                    color="success"
                    text
                    @click="handleAddProduct('submit')"
                  >
                    <v-icon class="mr-5">mdi-plus</v-icon>
                    เลือกรายการสินค้า
                    <v-chip class="chip" style="margin: 0 15px;">{{selectedProduct.length}}</v-chip>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-data-table
              :headers="headersDataAddProduct"
              :items="itemsTableDataAddProduct"
              item-key="id"
            >
              <template v-slot:item.image="{ item }">
                <v-img
                  :src="item.image"
                  width="30px"
                  style="margin: auto"
                ></v-img>
              </template>

              <template v-slot:item.price="{ item }">
                <v-text-field
                  reverse
                  v-model.number="item.price"
                  :value="item.price"
                  @keypress="handleInputNumber"
                  ref="price"
                  :rules="rule.orderSelectedPrice"
                ></v-text-field>
              </template>

              <template v-slot:item.qtySale="{ item }">
                <div
                  style="display: grid; grid-template-columns: 70% 30%"
                >
                  <v-text-field
                    reverse
                    v-model.number="item.buyQty"
                    :value="item.qty"
                    @keypress="handleInputNumber"
                    ref="qty"
                    :rules="rule.orderSelectedQTY"
                  ></v-text-field>
                  <label
                    style="align-self: center;"
                  >&nbsp;/&nbsp;{{numberWithComma(item.qty)}}</label>
                </div>
              </template>

              <template v-slot:item.discountPercent="{ item }">
                <v-text-field
                  reverse
                  v-model.number="item.discountPercent"
                  :value="item.discountPercent"
                  @keypress="handleInputNumber"
                  ref="discountPercent"
                ></v-text-field>
              </template>

              <template v-slot:item.discount="{ item }">
                <v-text-field
                  reverse
                  :value="item.buyQty
                    ? formatCurrency(((item.buyQty * item.price) * (item.discountPercent / 100)))
                    : formatCurrency(0)"
                  disabled
                ></v-text-field>
              </template>

              <template v-slot:item.total="{ item }">
                <v-text-field
                  reverse
                  :value="item.buyQty
                    ? formatCurrency(
                        (item.buyQty * item.price) - ((item.buyQty * item.price) * (item.discountPercent / 100))
                      )
                    : formatCurrency(0)"
                  disabled
                ></v-text-field>
              </template>

              <template v-slot:item.action="{ item }">
                <v-icon
                  @click="alertDelete(item)"
                >
                  mdi-delete
                </v-icon>
              </template>

            </v-data-table>
          </v-col>
        </v-row>

        <v-row>
          <v-divider style="margin: 10px 0"></v-divider>
        </v-row>

        <v-row class="d-flex flex-row-reverse">
          <v-col sm="12" md="6" lg="6" cols="12" class="pa-5">
            <v-row>
              <v-col class="col-8">ภาษีมูลค่าเพิ่ม</v-col>
              <v-col class="col-4 d-flex flex-row-reverse">0.00</v-col>
            </v-row>
            <v-row>
              <v-divider style="margin: 5px 0"></v-divider>
            </v-row>
            <v-row  class="pr-3">
              <v-col class="col-8">การจัดส่ง</v-col>
              <v-col class="col-4 pa-0">
                <v-text-field
                  reverse
                  height=20
                  placeholder="0.00"
                  hide-details="auto"
                  dense
                        autocomplete="off"
                  class="mt-4"
                  @keypress="handleInputNumber"
                  v-model.number="shippingPrice"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-divider style="margin: 5px 0"></v-divider>
            </v-row>
            <v-row class="pr-3">
              <v-col class="col-8">ค่าบริการ</v-col>
              <v-col class="col-4 pa-0">
                <v-text-field
                  reverse
                  height=20
                  placeholder="0.00"
                  hide-details="auto"
                  dense
                        autocomplete="off"
                  class="mt-4"
                  @keypress="handleInputNumber"
                  v-model.number="serviceCharge"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="col-8">รวมสุทธิ</v-col>
              <v-col class="col-4 d-flex flex-row-reverse">
                <!-- <b> {{totalPrice[totalPrice.length - 1]}} </b> -->
                <b> {{formatCurrency(totalPrice)}} </b>
              </v-col>
            </v-row>

          </v-col>
        </v-row>
        <v-row>
          <v-divider></v-divider>
        </v-row>
        <v-row  class="d-flex flex-row-reverse">
          <v-col sm="12" md="12" lg="3" cols="12">
            <v-btn
              color="success"
              depressed
              width="100%"
              class="pa-5"
              v-on:click="$route && $route.name === 'OrderCreate' ? handleInsertData() : handleEditData()"
            >
              <v-icon>mdi-content-save</v-icon>
              {{this.$route.name === 'OrderCreate' ? 'บันทึกรายการ' : 'แก้ไขรายการ'}}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-dialog
      v-model="dialogDeleteProductSelected"
      max-width="290"
    >
      <v-card>
        <v-card-text class="pt-5"><b>ต้องการลบ ?</b></v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="error"
            @click="dialogDeleteProductSelected = false"
            depressed
          >
            ยกเลิก
          </v-btn>

          <v-btn
            color="success"
            depressed
            v-on:click="deleteItem()"
          >
            ยืนยัน
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import ScriptFrom from '@/views/pages/order/form/form.script';

export default ScriptFrom;
</script>

<style lang="scss" scoped>
  @import '@/views/pages/order/form/form.style.scss';
</style>
